import * as React from 'react'
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group'

import { cn } from 'utils/classMerge'

export const Root = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
  return <RadioGroupPrimitive.Root className={className} {...props} ref={ref} />
})
Root.displayName = RadioGroupPrimitive.Root.displayName

export const Item = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        'focus-visible:tw-ring-ring tw-m-0 tw-aspect-square tw-max-h-8 tw-max-w-4 tw-appearance-none tw-rounded-full tw-border tw-border-solid tw-border-zinc-300 tw-bg-white tw-transition-all [tw--webkit-appearance:none] [tw-background-color:transparent] hover:tw-border-orange-500 focus:tw-outline-none focus-visible:tw-ring-1 disabled:tw-cursor-not-allowed disabled:tw-opacity-50 data-[state=checked]:tw-border-orange-500 data-[state=checked]:tw-bg-orange-500',
        className,
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator className="tw-grid tw-place-content-center">
        <div className="tw-h-2 tw-w-2 tw-rounded-full tw-bg-white" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  )
})
Item.displayName = RadioGroupPrimitive.Item.displayName
